import { ArrowRight, Mail } from "lucide-react";
import { CONTACT_EMAIL } from "./Navbar";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#FDFBF7] pt-10 pb-20 lg:pt-16 lg:pb-32"
    >
      {/* Subtle organic decorations */}
      <div className="absolute -top-32 -right-24 w-[420px] h-[420px] rounded-full bg-[#E6EAE3] blur-3xl opacity-70 pointer-events-none" />
      <div className="absolute -bottom-24 -left-16 w-[320px] h-[320px] rounded-full bg-[#F3EFE9] blur-3xl opacity-70 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <span className="eyebrow" data-testid="hero-eyebrow">
            Healthcare Business Acquisitions
          </span>

          <h1
            data-testid="hero-headline"
            className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight mt-6 text-[#1A2621]"
          >
            Ready to sell the
            <span className="block italic text-[#284A3B]">
              healthcare business
            </span>
            you’ve built?
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-8 max-w-2xl text-lg md:text-xl text-[#4A5D54] leading-relaxed"
          >
            We acquire home care, assisted living, sober living and career
            support businesses at <strong className="text-[#1A2621]">3–5× earnings</strong>,
            with financing already in place — and a process that protects your
            staff, your residents, and your legacy.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#submit"
              data-testid="hero-primary-cta"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("submit")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center gap-2 bg-[#C86A51] hover:bg-[#B35A42] text-white rounded-full px-8 py-4 font-medium transition-colors shadow-sm group"
            >
              Submit Your Business
              <ArrowRight
                size={18}
                className="transition-transform group-hover:translate-x-1"
              />
            </a>

            <a
              href={`mailto:${CONTACT_EMAIL}?subject=Business%20For%20Sale%20Inquiry`}
              data-testid="hero-secondary-cta"
              className="inline-flex items-center justify-center gap-2 bg-transparent border border-[#284A3B] text-[#284A3B] hover:bg-[#284A3B] hover:text-[#FDFBF7] rounded-full px-8 py-4 font-medium transition-colors"
            >
              <Mail size={16} /> Email Us Directly
            </a>
          </div>

          <div className="mt-12 flex flex-wrap gap-x-10 gap-y-5 text-sm text-[#4A5D54]">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#C86A51]" />
              Confidential by default
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#C86A51]" />
              No brokers — direct buyer
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#C86A51]" />
              Financing already secured
            </div>
          </div>
        </div>

        <div
          data-testid="hero-image"
          className="lg:col-span-5 relative"
        >
          <div className="relative rounded-[2rem] overflow-hidden border border-[#D5DACF] shadow-sm aspect-[4/5]">
            <img
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&q=80"
              alt="Two healthcare professionals shaking hands"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1A2621]/40 via-transparent to-transparent" />
          </div>

          {/* Floating badge */}
          <div className="absolute -left-6 bottom-10 bg-white rounded-2xl border border-[#D5DACF] shadow-md p-5 max-w-[220px] hidden md:block">
            <div className="font-serif-display text-3xl text-[#284A3B] leading-none">
              3–5×
            </div>
            <div className="text-xs uppercase tracking-[0.18em] text-[#4A5D54] mt-2">
              Earnings multiple offered
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
